//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { SuperAgentStatic, SuperAgentRequest, Response } from 'superagent';
import {
  CallbackHandler,
  RequestHeadersHandler,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  RequestHeaders,
  QueryParameters,
  CommonRequestOptions,
  ResponseWithBody,
} from './types';

export type ObjectResponseMetadataResponseWrapperWithMeta = {
  data?: void;
  metadata?: ResponseMetadata;
};

export type Operation = {
  from?: string;
  op?: string;
  operationType?: OperationType;
  path?: string;
  value?: void;
};

export type OperationType = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export type ResponseMetadata = {
  requestId?: string;
};

export type StatusChangeDto = {
  message?: string;
  status?: string;
  timestamp?: string;
};

export type TableUpdateDetailsDto = {
  comments?: string;
  createdAt?: string;
  createdBy?: string;
  filePath?: string;
  history?: Array<StatusChangeDto>;
  id?: string;
  message?: string;
  rowCount?: number;
  status?: string;
  tableId?: string;
  transferComplete?: boolean;
  type?: string;
};

export type TableUpdateDetailsDtoResponseMetadataResponseWrapperWithMeta = {
  data?: TableUpdateDetailsDto;
  metadata?: ResponseMetadata;
};

export type TableUpdateDto = {
  comments?: string;
  createdAt?: string;
  createdBy?: string;
  id?: string;
  message?: string;
  status?: string;
  tableId?: string;
};

export type TableUpdateDtoArrayResponseMetadataResponseWrapperWithMeta = {
  data?: Array<TableUpdateDto>;
  metadata?: ResponseMetadata;
};

export type TableUpdateDtoResponseMetadataResponseWrapperWithMeta = {
  data?: TableUpdateDto;
  metadata?: ResponseMetadata;
};

export type TableUpdateRequestDto = {
  comments?: string;
  filePath?: string;
  message?: string;
  rowCount?: number;
  status?: string;
  transferComplete?: boolean;
  type?: string;
};

/**
 * Insight2Profit DataLoadService
 * @class DataLoadService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class DataLoadService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      req.send(body);

      if (typeof body === 'object' && !(body.constructor.name === 'Buffer')) {
        headers['Content-Type'] = 'application/json';
      }
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name DataLoadService#getDataLoadClientsByClientIdTablesByTableIdUpdates
   * @description /data-load/clients/{clientId}/tables/{tableId}/updates
   * @param {string} clientId - Insight2Profit DataLoadService
   * @param {string} tableId - Insight2Profit DataLoadService
   */
  getDataLoadClientsByClientIdTablesByTableIdUpdates(
    parameters: {
      clientId: string;
      tableId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, TableUpdateDtoArrayResponseMetadataResponseWrapperWithMeta>
    | ResponseWithBody<401, void>
    | ResponseWithBody<403, void>
    | ResponseWithBody<404, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/data-load/clients/{clientId}/tables/{tableId}/updates';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DataLoadService#postDataLoadClientsByClientIdTablesByTableIdUpdates
   * @description /data-load/clients/{clientId}/tables/{tableId}/updates
   * @param {string} clientId - Insight2Profit DataLoadService
   * @param {string} tableId - Insight2Profit DataLoadService
   * @param {} body - Insight2Profit DataLoadService
   */
  postDataLoadClientsByClientIdTablesByTableIdUpdates(
    parameters: {
      clientId: string;
      tableId: string;
      body?: TableUpdateRequestDto;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<201, TableUpdateDtoResponseMetadataResponseWrapperWithMeta>
    | ResponseWithBody<400, void>
    | ResponseWithBody<401, void>
    | ResponseWithBody<403, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/data-load/clients/{clientId}/tables/{tableId}/updates';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DataLoadService#getDataLoadClientsByClientIdTablesByTableIdUpdatesByUpdateId
   * @description /data-load/clients/{clientId}/tables/{tableId}/updates/{updateId}
   * @param {string} clientId - Insight2Profit DataLoadService
   * @param {string} tableId - Insight2Profit DataLoadService
   * @param {string} updateId - Insight2Profit DataLoadService
   */
  getDataLoadClientsByClientIdTablesByTableIdUpdatesByUpdateId(
    parameters: {
      clientId: string;
      tableId: string;
      updateId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, TableUpdateDetailsDtoResponseMetadataResponseWrapperWithMeta>
    | ResponseWithBody<401, void>
    | ResponseWithBody<403, void>
    | ResponseWithBody<404, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/data-load/clients/{clientId}/tables/{tableId}/updates/{updateId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      path = path.replace('{updateId}', `${parameters['updateId']}`);

      if (parameters['updateId'] === undefined) {
        reject(new Error('Missing required  parameter: updateId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DataLoadService#patchDataLoadClientsByClientIdTablesByTableIdUpdatesByUpdateId
   * @description /data-load/clients/{clientId}/tables/{tableId}/updates/{updateId}
   * @param {string} clientId - Insight2Profit DataLoadService
   * @param {string} tableId - Insight2Profit DataLoadService
   * @param {string} updateId - Insight2Profit DataLoadService
   * @param {} body - Insight2Profit DataLoadService
   */
  patchDataLoadClientsByClientIdTablesByTableIdUpdatesByUpdateId(
    parameters: {
      clientId: string;
      tableId: string;
      updateId: string;
      body?: Array<Operation>;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, ObjectResponseMetadataResponseWrapperWithMeta>
    | ResponseWithBody<400, void>
    | ResponseWithBody<401, void>
    | ResponseWithBody<403, void>
    | ResponseWithBody<404, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/data-load/clients/{clientId}/tables/{tableId}/updates/{updateId}';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      path = path.replace('{tableId}', `${parameters['tableId']}`);

      if (parameters['tableId'] === undefined) {
        reject(new Error('Missing required  parameter: tableId'));
        return;
      }

      path = path.replace('{updateId}', `${parameters['updateId']}`);

      if (parameters['updateId'] === undefined) {
        reject(new Error('Missing required  parameter: updateId'));
        return;
      }

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('PATCH', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }

  /**
   *
   * @method
   * @name DataLoadService#getDataLoadClientsByClientIdUpdates
   * @description /data-load/clients/{clientId}/updates
   * @param {string} clientId - Insight2Profit DataLoadService
   */
  getDataLoadClientsByClientIdUpdates(
    parameters: {
      clientId: string;
    } & CommonRequestOptions
  ): Promise<
    | ResponseWithBody<200, TableUpdateDtoArrayResponseMetadataResponseWrapperWithMeta>
    | ResponseWithBody<401, void>
    | ResponseWithBody<403, void>
    | ResponseWithBody<404, void>
  > {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/data-load/clients/{clientId}/updates';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';

      path = path.replace('{clientId}', `${parameters['clientId']}`);

      if (parameters['clientId'] === undefined) {
        reject(new Error('Missing required  parameter: clientId'));
        return;
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      this.request('GET', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default DataLoadService;
